import axios from 'axios';

/**
 * True when a request was cancelled through its caller's AbortSignal, rather
 * than failing. axios 1.x rejects with a CanceledError; native fetch rejects
 * with a DOMException named AbortError. A cancel is neither a success nor a
 * failure -- the caller no longer wants the response -- so it must not be
 * logged as an error, counted in success/latency metrics, or retried.
 *
 * axios 0.21 ignored `signal` entirely, so before the 1.x upgrade superseded
 * requests ran to completion and this case never arose.
 */
const isAbortError = (error: unknown): boolean =>
  axios.isCancel(error) ||
  (typeof error === 'object' &&
    error !== null &&
    (error as { name?: unknown }).name === 'AbortError');

export default isAbortError;
